"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _userflow = require("../../utils/userflow");
var _ButtonTs = _interopRequireDefault(require("../ButtonTs"));
var _FacilitiesList = _interopRequireDefault(require("../FacilitiesList"));
var _HotelRoomName = _interopRequireDefault(require("./HotelRoomName"));
var _HotelRoomFacilities = _interopRequireDefault(require("./HotelRoomFacilities"));
var _LabelList = require("../Label/LabelList");
var _hotel = require("../../proptypes/hotel");
var _Bubble = _interopRequireDefault(require("../Bubble"));
var _ChevronDown = _interopRequireDefault(require("../../icons-react/rebrand/ChevronDown"));
var _excluded = ["roomName", "originalName", "area", "description", "facilities", "hotelFacilities", "labels"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HotelRoomDescription = /*#__PURE__*/function (_React$PureComponent) {
  function HotelRoomDescription(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, HotelRoomDescription);
    _this = _callSuper(this, HotelRoomDescription, [props]);
    _this.state = {
      expanded: false,
      openFacilitiesTooltip: false
    };
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    _this.handleOverflow = _this.handleOverflow.bind(_this);
    _this.setExpanded = function () {
      return _this.setState({
        expanded: true
      });
    };
    _this.setOpenFacilitiesTooltip = function () {
      var openFacilitiesTooltip = _this.state.openFacilitiesTooltip;
      _this.setState({
        openFacilitiesTooltip: !openFacilitiesTooltip
      });
    };
    return _this;
  }
  (0, _inherits2["default"])(HotelRoomDescription, _React$PureComponent);
  return (0, _createClass2["default"])(HotelRoomDescription, [{
    key: "shownFacilities",
    get: function get() {
      var facilities = this.props.facilities;
      var expanded = this.state.expanded;
      return facilities === null || facilities === void 0 ? void 0 : facilities.slice(0, expanded ? undefined : 8);
    }
  }, {
    key: "showSharedFacilitiesDropdown",
    get: function get() {
      var _this$props = this.props,
        hotelFacilities = _this$props.hotelFacilities,
        facilities = _this$props.facilities;
      var expanded = this.state.expanded;
      return expanded && (hotelFacilities === null || hotelFacilities === void 0 ? void 0 : hotelFacilities.length) || !expanded && (facilities === null || facilities === void 0 ? void 0 : facilities.length) < 8;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.observer = new _resizeObserverPolyfill["default"](this.handleOverflow);
      this.observer.observe(this.container);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.observer) {
        this.observer.unobserve(this.container);
      }
    }
  }, {
    key: "handleOverflow",
    value: function handleOverflow() {
      var showMore = this.state.showMore;
      if (showMore !== false) {
        var isOverflown = (0, _userflow.isElementOverflown)(this.container);
        this.setState({
          showMore: isOverflown || undefined
        });
      }
    }
  }, {
    key: "container",
    get: function get() {
      return (0, _get2["default"])(this, 'containerRef.current');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        roomName = _this$props2.roomName,
        originalName = _this$props2.originalName,
        area = _this$props2.area,
        description = _this$props2.description,
        facilities = _this$props2.facilities,
        hotelFacilities = _this$props2.hotelFacilities,
        labels = _this$props2.labels,
        rest = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var _this$state = this.state,
        expanded = _this$state.expanded,
        openFacilitiesTooltip = _this$state.openFacilitiesTooltip;
      var shownFacilities = this.shownFacilities;
      var showSharedFacilitiesDropdown = this.showSharedFacilitiesDropdown;
      return /*#__PURE__*/_react["default"].createElement(StyledHotelRoomDescription, (0, _extends2["default"])({}, rest, {
        ref: this.containerRef
      }), /*#__PURE__*/_react["default"].createElement(_HotelRoomName["default"], {
        name: roomName,
        originalName: originalName,
        area: area
      }), /*#__PURE__*/_react["default"].createElement(StyldLabelList, {
        labels: labels,
        maxLabels: 6
      }), /*#__PURE__*/_react["default"].createElement(StyledHotelRoomDescriptionWrapper, {
        expanded: expanded === false
      }, /*#__PURE__*/_react["default"].createElement(_HotelRoomFacilities["default"], {
        description: description,
        facilities: shownFacilities,
        inCard: true
      }), showSharedFacilitiesDropdown ? /*#__PURE__*/_react["default"].createElement(StyledBubble, {
        eventType: "click",
        width: "max",
        renderExtras: function renderExtras() {
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(StyledFacilitiesTitle, null, _localization.i18n.t('hotel.facilities.hasRooms')), /*#__PURE__*/_react["default"].createElement(_FacilitiesList["default"], {
            items: hotelFacilities,
            showItemCheck: true,
            inColumns: true,
            isMobile: false
          }));
        }
      }, /*#__PURE__*/_react["default"].createElement(StyledFacilitiesHintButton, {
        functional: true,
        onClick: this.setOpenFacilitiesTooltip
      }, /*#__PURE__*/_react["default"].createElement(StyledTooltipText, null, _localization.i18n.t('hotel.room.facilities')), /*#__PURE__*/_react["default"].createElement(StyledChervonDown, null))) : null), !expanded && (facilities === null || facilities === void 0 ? void 0 : facilities.length) > 8 ? /*#__PURE__*/_react["default"].createElement(ShowMoreButton, {
        onClick: this.setExpanded
      }, _localization.i18n.t('hotel.room.moreButton')) : null);
    }
  }]);
}(_react["default"].PureComponent);
HotelRoomDescription.defaultProps = {
  originalName: null,
  area: null,
  description: null,
  facilities: null,
  hotelFacilities: null,
  labels: []
};
HotelRoomDescription.propTypes = {
  roomName: _propTypes["default"].string.isRequired,
  originalName: _propTypes["default"].string,
  area: _propTypes["default"].number,
  description: _propTypes["default"].string,
  facilities: _propTypes["default"].arrayOf(_hotel.RoomFacilityPropTypes),
  hotelFacilities: _propTypes["default"].arrayOf(_hotel.HotelFacilityPropTypes),
  labels: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
};
var StyldLabelList = (0, _styledComponents["default"])(_LabelList.LabelList).withConfig({
  displayName: "HotelRoomDescription__StyldLabelList",
  componentId: "sc-1wjft0c-0"
})(["margin-top:8px;> div:last-child{margin-bottom:0;}"]);
var StyledHotelRoomDescription = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomDescription__StyledHotelRoomDescription",
  componentId: "sc-1wjft0c-1"
})(["position:relative;overflow:hidden;background:", ";"], function (props) {
  return props.theme.colors.white;
});
var ShowMoreButton = (0, _styledComponents["default"])(_ButtonTs["default"]).attrs({
  size: 'none'
}).withConfig({
  displayName: "HotelRoomDescription__ShowMoreButton",
  componentId: "sc-1wjft0c-2"
})(["background-color:var(--background);padding:12px 16px;font-size:14px;font-weight:400;line-height:16px;"]);
var StyledHotelRoomDescriptionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomDescription__StyledHotelRoomDescriptionWrapper",
  componentId: "sc-1wjft0c-3"
})(["position:relative;gap:0.5em;display:flex;flex-direction:column;"]);
var StyledFacilitiesHintButton = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomDescription__StyledFacilitiesHintButton",
  componentId: "sc-1wjft0c-4"
})(["color:var(--grey1);background-color:transparent;cursor:pointer;display:flex;align-items:center;", ""], function (_ref) {
  var $isOpened = _ref.$isOpened;
  return $isOpened && "color: var(--secondary);";
});
var StyledTooltipText = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomDescription__StyledTooltipText",
  componentId: "sc-1wjft0c-5"
})(["font-size:14px;line-height:16px;"]);
var StyledChervonDown = (0, _styledComponents["default"])(_ChevronDown["default"]).withConfig({
  displayName: "HotelRoomDescription__StyledChervonDown",
  componentId: "sc-1wjft0c-6"
})(["width:12px;height:12px;margin-left:2px;path{fill:var(--grey1);}", ""], function (_ref2) {
  var $isOpened = _ref2.$isOpened;
  return $isOpened && "\n    rotate: 180deg;\n\n    path {\n      fill: var(--secondary);\n    }\n";
});
var StyledBubble = (0, _styledComponents["default"])(_Bubble["default"]).withConfig({
  displayName: "HotelRoomDescription__StyledBubble",
  componentId: "sc-1wjft0c-7"
})(["width:max-content;max-width:none;"]);
var StyledFacilitiesTitle = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomDescription__StyledFacilitiesTitle",
  componentId: "sc-1wjft0c-8"
})(["font-weight:500;font-size:14px;line-height:16px;"]);
var _default = exports["default"] = HotelRoomDescription;